export * from './tab.component';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/components/tabs/index.ts